import { render, staticRenderFns } from "./IndirectServices.vue?vue&type=template&id=f1c2ba0e"
import script from "./IndirectServices.vue?vue&type=script&lang=js"
export * from "./IndirectServices.vue?vue&type=script&lang=js"
import style0 from "./IndirectServices.vue?vue&type=style&index=0&id=f1c2ba0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports